export const DEATH_DREAMS = {
  id: 'death',
  name: '죽음/사고 꿈',
  emoji: '💀',
  color: '#718096',
  description: '죽는 꿈, 사고 꿈, 장례식 꿈 등 죽음과 사고 관련 꿈 해몽',
  seoTitle: '죽음/사고 꿈해몽 - 죽음 관련 꿈 해석 총정리',
  seoDescription: '자신이 죽는 꿈, 교통사고 꿈, 장례식 꿈 등 죽음과 사고 관련 꿈의 의미를 알아보세요.',
  subjects: [
    {
      id: 'self-death',
      name: '자신이 죽는 꿈',
      emoji: '💀',
      summary: '자신이 죽는 꿈은 역설적으로 새로운 시작과 변화를 상징합니다.',
      seoTitle: '자신이 죽는 꿈 해몽 - 내가 죽는 꿈 해석',
      seoDescription: '자신이 죽는 꿈, 죽어서 되살아나는 꿈 등의 해몽을 확인하세요.',
      scenarios: [
        { id: 'die-self', title: '자신이 죽는 꿈', interpretation: '자신이 죽는 꿈은 역설적으로 대길몽입니다. 현재의 자신이 끝나고 새로운 자신으로 다시 태어나는 것을 의미합니다. 인생의 큰 전환점이 되며, 좋은 변화가 찾아올 것입니다.', omen: 'good', luckyNumbers: [1, 9, 18, 27, 36, 45], tags: ['대길', '변화'] },
        { id: 'die-revive', title: '죽었다가 살아나는 꿈', interpretation: '죽었다가 살아나는 꿈은 어려운 시기를 극복하고 재기할 것을 의미합니다. 불사조처럼 더 강하게 돌아올 수 있습니다.', omen: 'good', luckyNumbers: [3, 10, 19, 28, 37, 44], tags: ['재기', '극복'] },
        { id: 'die-peaceful', title: '평화롭게 죽는 꿈', interpretation: '평화롭게 죽는 꿈은 현재의 고민과 걱정이 모두 해결되고 마음의 평화를 찾게 될 것을 의미합니다.', omen: 'good', luckyNumbers: [5, 14, 23, 32, 38, 43], tags: ['평화', '해소'] },
        { id: 'die-violent', title: '갑작스럽게 죽는 꿈', interpretation: '갑작스럽게 죽는 꿈은 인생에 급격한 변화가 올 것을 암시합니다. 두렵지만 이 변화는 결국 좋은 방향으로 이끌어 줄 것입니다.', omen: 'caution', luckyNumbers: [4, 12, 21, 30, 39, 42], tags: ['급변', '전환'] },
        { id: 'see-own-funeral', title: '자신의 장례식을 보는 꿈', interpretation: '자신의 장례식을 보는 꿈은 주변 사람들이 나를 어떻게 생각하는지 알게 되는 것을 의미합니다. 인간관계를 점검하는 좋은 기회입니다.', omen: 'caution', luckyNumbers: [2, 8, 17, 26, 35, 41], tags: ['관계', '점검'] },
      ]
    },
    {
      id: 'others-death',
      name: '다른 사람이 죽는 꿈',
      emoji: '⚰️',
      summary: '다른 사람이 죽는 꿈은 관계 변화나 그 사람에 대한 걱정을 반영합니다.',
      seoTitle: '다른 사람이 죽는 꿈 해몽 - 남이 죽는 꿈 해석',
      seoDescription: '가족이 죽는 꿈, 친구가 죽는 꿈, 모르는 사람이 죽는 꿈 등의 해몽을 확인하세요.',
      scenarios: [
        { id: 'family-die', title: '가족이 죽는 꿈', interpretation: '가족이 죽는 꿈은 그 가족에 대한 깊은 걱정이나 관계의 변화를 의미합니다. 실제 죽음을 의미하는 것이 아니라, 관계가 새롭게 재편될 수 있습니다. 가족에게 사랑을 표현하세요.', omen: 'caution', luckyNumbers: [3, 10, 19, 28, 37, 43], tags: ['걱정', '관계'] },
        { id: 'friend-die', title: '친구가 죽는 꿈', interpretation: '친구가 죽는 꿈은 그 친구와의 관계에 변화가 올 수 있음을 의미합니다. 또는 그 친구가 상징하는 자신의 특성이 변화하는 것일 수 있습니다.', omen: 'caution', luckyNumbers: [4, 12, 21, 30, 38, 42], tags: ['변화', '관계'] },
        { id: 'stranger-die', title: '모르는 사람이 죽는 꿈', interpretation: '모르는 사람이 죽는 꿈은 자신의 일부가 끝나고 새롭게 시작되는 것을 의미합니다. 과거의 습관이나 성격이 변화하는 과정입니다.', omen: 'good', luckyNumbers: [1, 9, 18, 27, 36, 44], tags: ['변화', '새시작'] },
        { id: 'enemy-die', title: '적이나 싫어하는 사람이 죽는 꿈', interpretation: '적이나 싫어하는 사람이 죽는 꿈은 갈등이 해소되거나 경쟁에서 승리할 것을 의미합니다. 스트레스 원인이 사라질 수 있습니다.', omen: 'good', luckyNumbers: [5, 13, 22, 31, 39, 45], tags: ['해소', '승리'] },
        { id: 'pet-die', title: '반려동물이 죽는 꿈', interpretation: '반려동물이 죽는 꿈은 순수한 감정이나 즐거움이 줄어들고 있다는 경고입니다. 일상에서 소소한 즐거움을 찾아보세요.', omen: 'caution', luckyNumbers: [2, 8, 17, 26, 35, 41], tags: ['감정', '즐거움'] },
      ]
    },
    {
      id: 'accident',
      name: '사고 꿈',
      emoji: '🚨',
      summary: '사고꿈은 경고, 주의, 방향 전환을 상징합니다.',
      seoTitle: '사고꿈 해몽 - 사고 나는 꿈 해석',
      seoDescription: '교통사고 꿈, 추락사고 꿈, 화재 꿈 등 사고꿈의 해몽을 확인하세요.',
      scenarios: [
        { id: 'car-crash', title: '교통사고가 나는 꿈', interpretation: '교통사고가 나는 꿈은 현재 진행 중인 일에 장애가 생길 수 있다는 경고입니다. 서두르지 말고 안전하게 진행하세요. 실제 운전에도 주의하세요.', omen: 'caution', luckyNumbers: [4, 11, 20, 29, 34, 40], tags: ['경고', '안전'] },
        { id: 'plane-crash', title: '비행기 사고 꿈', interpretation: '비행기 사고 꿈은 높은 목표에 대한 불안감을 나타냅니다. 목표가 너무 높지는 않은지 점검하되, 포기하지는 마세요.', omen: 'caution', luckyNumbers: [3, 10, 19, 28, 37, 42], tags: ['불안', '점검'] },
        { id: 'fire-accident', title: '화재 사고 꿈', interpretation: '화재 사고 꿈은 감정이 폭발하거나 갑작스러운 위기가 올 수 있음을 경고합니다. 하지만 불이 진화되면 위기를 극복할 수 있습니다.', omen: 'caution', luckyNumbers: [5, 14, 23, 32, 38, 43], tags: ['위기', '극복'] },
        { id: 'natural-disaster', title: '자연재해를 겪는 꿈', interpretation: '자연재해를 겪는 꿈은 통제할 수 없는 큰 변화가 올 수 있음을 의미합니다. 유연하게 대처하면 오히려 더 나은 결과를 얻을 수 있습니다.', omen: 'caution', luckyNumbers: [6, 13, 22, 31, 39, 44], tags: ['변화', '유연'] },
        { id: 'witness-accident', title: '사고를 목격하는 꿈', interpretation: '사고를 목격하는 꿈은 주변에서 주의가 필요한 상황이 발생할 수 있음을 경고합니다. 가까운 사람들의 안전에 신경 쓰세요.', omen: 'caution', luckyNumbers: [2, 10, 19, 28, 35, 41], tags: ['주의', '안전'] },
        { id: 'survive-accident', title: '사고에서 살아남는 꿈', interpretation: '사고에서 살아남는 꿈은 어떤 어려움도 극복할 수 있는 강한 생존력을 가지고 있음을 의미합니다. 위기를 기회로 바꿀 수 있습니다.', omen: 'good', luckyNumbers: [1, 7, 14, 28, 35, 45], tags: ['극복', '생존'] },
      ]
    },
    {
      id: 'funeral',
      name: '장례식 꿈',
      emoji: '🪦',
      summary: '장례식꿈은 마무리, 이별, 새로운 시작을 상징합니다.',
      seoTitle: '장례식꿈 해몽 - 장례식 나오는 꿈 해석',
      seoDescription: '장례식에 참석하는 꿈, 상복을 입는 꿈, 무덤 꿈 등의 해몽을 확인하세요.',
      scenarios: [
        { id: 'attend-funeral', title: '장례식에 참석하는 꿈', interpretation: '장례식에 참석하는 꿈은 인생의 한 장이 마무리되고 새로운 장이 시작될 것을 의미합니다. 과거를 정리하고 새롭게 시작하세요.', omen: 'good', luckyNumbers: [1, 9, 18, 27, 36, 44], tags: ['마무리', '새시작'] },
        { id: 'mourning-clothes', title: '상복을 입는 꿈', interpretation: '상복을 입는 꿈은 엄숙한 자세로 중요한 일에 임해야 할 때를 의미합니다. 진지한 태도가 좋은 결과를 가져올 것입니다.', omen: 'caution', luckyNumbers: [3, 10, 19, 28, 37, 43], tags: ['진지', '태도'] },
        { id: 'grave', title: '무덤을 보는 꿈', interpretation: '무덤을 보는 꿈은 과거에 묻어둔 것을 되돌아보라는 의미입니다. 해결하지 못한 문제를 마무리하면 마음이 편안해집니다.', omen: 'caution', luckyNumbers: [4, 12, 21, 30, 38, 42], tags: ['과거', '정리'] },
        { id: 'coffin', title: '관을 보는 꿈', interpretation: '관을 보는 꿈은 큰 재물이 들어올 수 있는 길몽입니다. 전통적으로 관을 보는 꿈은 재물운과 연결됩니다.', omen: 'good', luckyNumbers: [7, 14, 23, 32, 38, 45], tags: ['재물운', '길몽'] },
        { id: 'cry-funeral', title: '장례식에서 슬프게 우는 꿈', interpretation: '장례식에서 슬프게 우는 꿈은 감정이 정화되고 새로운 시작을 위한 준비가 되었음을 의미합니다. 눈물 뒤에 기쁨이 찾아옵니다.', omen: 'good', luckyNumbers: [2, 8, 17, 26, 35, 42], tags: ['정화', '기쁨'] },
      ]
    },
    {
      id: 'ghost',
      name: '귀신 꿈',
      emoji: '👻',
      summary: '귀신꿈은 두려움, 과거, 미해결 감정을 상징합니다.',
      seoTitle: '귀신꿈 해몽 - 귀신 나오는 꿈 해석',
      seoDescription: '귀신을 보는 꿈, 귀신에게 쫓기는 꿈, 귀신과 대화하는 꿈 등의 해몽을 확인하세요.',
      scenarios: [
        { id: 'see-ghost', title: '귀신을 보는 꿈', interpretation: '귀신을 보는 꿈은 해결하지 못한 과거의 문제나 감정이 있음을 의미합니다. 과거를 직면하고 정리하면 마음이 편안해질 것입니다.', omen: 'caution', luckyNumbers: [4, 11, 20, 29, 37, 42], tags: ['과거', '정리'] },
        { id: 'ghost-chase', title: '귀신에게 쫓기는 꿈', interpretation: '귀신에게 쫓기는 꿈은 현실에서 피하고 싶은 문제가 있음을 나타냅니다. 용기를 내어 문제와 맞서면 해결할 수 있습니다.', omen: 'caution', luckyNumbers: [3, 10, 19, 28, 36, 43], tags: ['직면', '용기'] },
        { id: 'ghost-talk', title: '귀신과 대화하는 꿈', interpretation: '귀신과 대화하는 꿈은 자신의 무의식과 소통하는 것을 의미합니다. 대화 내용에 중요한 메시지가 담겨있을 수 있으니 기억해보세요.', omen: 'caution', luckyNumbers: [5, 13, 22, 31, 39, 44], tags: ['무의식', '메시지'] },
        { id: 'ghost-friendly', title: '친근한 귀신이 나오는 꿈', interpretation: '친근한 귀신이 나오는 꿈은 돌아가신 분이나 보호자의 영혼이 당신을 지켜보고 있다는 의미입니다. 보호받고 있음을 느끼세요.', omen: 'good', luckyNumbers: [1, 9, 18, 27, 36, 45], tags: ['보호', '위안'] },
        { id: 'defeat-ghost', title: '귀신을 물리치는 꿈', interpretation: '귀신을 물리치는 꿈은 두려움을 극복하고 문제를 해결할 수 있다는 길몽입니다. 자신감을 가지고 나아가세요.', omen: 'good', luckyNumbers: [7, 14, 23, 32, 38, 44], tags: ['극복', '자신감'] },
      ]
    },
    {
      id: 'war',
      name: '전쟁 꿈',
      emoji: '⚔️',
      summary: '전쟁꿈은 내면의 갈등, 경쟁, 극한 상황을 상징합니다.',
      seoTitle: '전쟁꿈 해몽 - 전쟁 나오는 꿈 해석',
      seoDescription: '전쟁이 나는 꿈, 군인 꿈, 전투 꿈 등의 해몽을 확인하세요.',
      scenarios: [
        { id: 'war-break', title: '전쟁이 일어나는 꿈', interpretation: '전쟁이 일어나는 꿈은 내면의 큰 갈등이나 외부와의 충돌을 의미합니다. 하지만 전쟁이 끝나면 더 강한 평화가 찾아옵니다.', omen: 'caution', luckyNumbers: [4, 12, 21, 30, 38, 43], tags: ['갈등', '변화'] },
        { id: 'soldier', title: '군인이 되는 꿈', interpretation: '군인이 되는 꿈은 규율과 훈련이 필요한 시기를 의미합니다. 자기 절제와 훈련을 통해 더 강해질 수 있습니다.', omen: 'caution', luckyNumbers: [1, 8, 17, 26, 35, 42], tags: ['훈련', '절제'] },
        { id: 'war-win', title: '전투에서 승리하는 꿈', interpretation: '전투에서 승리하는 꿈은 어려운 경쟁이나 갈등에서 이길 것을 의미합니다. 자신의 능력을 믿고 끝까지 싸우세요.', omen: 'good', luckyNumbers: [3, 10, 19, 28, 37, 45], tags: ['승리', '경쟁'] },
        { id: 'war-end', title: '전쟁이 끝나는 꿈', interpretation: '전쟁이 끝나는 꿈은 갈등이 해소되고 평화로운 시기가 찾아올 것을 의미합니다. 마음의 평온을 되찾게 됩니다.', omen: 'good', luckyNumbers: [5, 14, 23, 32, 39, 44], tags: ['평화', '해소'] },
      ]
    },
    {
      id: 'drowning',
      name: '익사 꿈',
      emoji: '🌊',
      summary: '익사꿈은 감정에 압도됨, 통제 상실을 상징합니다.',
      seoTitle: '익사꿈 해몽 - 물에 빠지는 꿈 해석',
      seoDescription: '물에 빠져 죽는 꿈, 누군가를 구하는 꿈 등의 해몽을 확인하세요.',
      scenarios: [
        { id: 'drowning-self', title: '물에 빠져 죽는 꿈', interpretation: '물에 빠져 죽는 꿈은 감정에 휩쓸리고 있다는 경고이면서, 동시에 감정적 정화와 새로운 시작을 의미합니다. 감정을 다스리는 법을 배우세요.', omen: 'caution', luckyNumbers: [4, 11, 20, 29, 37, 42], tags: ['감정', '정화'] },
        { id: 'rescue-drowning', title: '물에 빠진 사람을 구하는 꿈', interpretation: '물에 빠진 사람을 구하는 꿈은 주변 사람을 도울 기회가 올 것을 의미합니다. 도움을 주면 큰 보답이 돌아옵니다.', omen: 'good', luckyNumbers: [1, 9, 18, 27, 36, 44], tags: ['도움', '보답'] },
        { id: 'saved-drowning', title: '물에 빠졌다 구조되는 꿈', interpretation: '물에 빠졌다 구조되는 꿈은 위기에서 벗어나 귀인의 도움을 받게 될 것을 의미합니다. 도움의 손길을 거부하지 마세요.', omen: 'good', luckyNumbers: [3, 10, 19, 28, 35, 43], tags: ['구조', '귀인'] },
        { id: 'swim-survive', title: '물에서 헤엄쳐 살아나는 꿈', interpretation: '물에서 스스로 헤엄쳐 살아나는 꿈은 자신의 힘으로 어려움을 극복할 수 있다는 강한 메시지입니다. 자신감을 가지세요.', omen: 'good', luckyNumbers: [5, 14, 23, 32, 38, 45], tags: ['자력', '극복'] },
      ]
    },
    {
      id: 'murder',
      name: '살인 꿈',
      emoji: '🔪',
      summary: '살인꿈은 과거의 단절, 강한 변화 의지를 상징합니다.',
      seoTitle: '살인꿈 해몽 - 누군가를 죽이는 꿈 해석',
      seoDescription: '사람을 죽이는 꿈, 살인을 목격하는 꿈 등의 해몽을 확인하세요.',
      scenarios: [
        { id: 'kill-someone', title: '누군가를 죽이는 꿈', interpretation: '누군가를 죽이는 꿈은 과거의 자신이나 나쁜 습관을 없애고자 하는 강한 의지를 나타냅니다. 실제 폭력과는 관계없으며, 변화에 대한 강한 열망입니다.', omen: 'good', luckyNumbers: [1, 8, 17, 26, 35, 44], tags: ['변화', '의지'] },
        { id: 'witness-murder', title: '살인을 목격하는 꿈', interpretation: '살인을 목격하는 꿈은 주변에서 큰 변화가 일어나는 것을 지켜보게 될 것을 의미합니다. 변화에 대비하고, 자신의 입장을 잘 정리하세요.', omen: 'caution', luckyNumbers: [3, 12, 21, 30, 38, 42], tags: ['변화', '대비'] },
        { id: 'almost-killed', title: '죽임당할 뻔하는 꿈', interpretation: '죽임당할 뻔하는 꿈은 위기에서 벗어나 새로운 기회를 얻게 될 것을 의미합니다. 위험이 지나가면 더 강해질 것입니다.', omen: 'caution', luckyNumbers: [5, 14, 23, 32, 39, 43], tags: ['위기', '기회'] },
      ]
    },
    {
      id: 'hospital-death',
      name: '병사 꿈',
      emoji: '🏥',
      summary: '병으로 죽는 꿈은 건강 관리, 치유, 회복을 상징합니다.',
      seoTitle: '병으로 죽는 꿈 해몽 - 병사 꿈 해석',
      seoDescription: '병으로 죽는 꿈, 불치병 꿈 등의 해몽을 확인하세요.',
      scenarios: [
        { id: 'die-illness', title: '병으로 죽는 꿈', interpretation: '병으로 죽는 꿈은 건강에 대한 경고이면서, 현재의 나쁜 상태가 끝나고 회복될 것을 의미합니다. 건강 검진을 받고, 생활 습관을 개선하세요.', omen: 'caution', luckyNumbers: [3, 10, 19, 28, 37, 43], tags: ['건강', '회복'] },
        { id: 'terminal-illness', title: '불치병에 걸리는 꿈', interpretation: '불치병에 걸리는 꿈은 현재 해결이 어려운 문제에 직면해 있음을 의미합니다. 하지만 전문가의 도움을 받으면 길이 열릴 수 있습니다.', omen: 'caution', luckyNumbers: [4, 12, 21, 30, 38, 41], tags: ['도전', '도움'] },
        { id: 'heal-illness', title: '병이 낫는 꿈', interpretation: '병이 낫는 꿈은 건강이 회복되고, 문제가 해결될 길몽입니다. 오랫동안 괴로웠던 일이 마침내 해결됩니다.', omen: 'good', luckyNumbers: [1, 7, 14, 28, 35, 45], tags: ['회복', '해결'] },
      ]
    },
  ]
};
